import { render, staticRenderFns } from "./DeliveriesStep.vue?vue&type=template&id=547d2324&scoped=true"
import script from "./DeliveriesStep.vue?vue&type=script&lang=js"
export * from "./DeliveriesStep.vue?vue&type=script&lang=js"
import style0 from "./DeliveriesStep.vue?vue&type=style&index=0&id=547d2324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547d2324",
  null
  
)

export default component.exports